import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useState } from 'react';
import {useNavigate} from 'react-router';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ResponsiveAppBar from '../component/Navbar/Navbar';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="/">
       Material+
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const defaultTheme = createTheme();
let userData = [{name:"Srijan Internal", email: "ds-internal-dev@srijan.net", password:"srijan@123", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVhtFJc9v3hEBfhJiOhYMS_60ieEbiOjPJyxl8F2dIBw&s"}]


export default function SignIn() {
  const [input, setInput] = useState({
    email: "",
    password: ""
});
const [errorMessage, setErrorMessage] = useState('');
let error = true
  const closeError = () =>{
    error = false;
    window.location.reload();
  }
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    event.preventDefault();

    if (input.email && input.password){
      userData.map((cred) => {
        if(input.email ===  cred.email && input.password === cred.password){
          localStorage.setItem("logged in", true);
          localStorage.setItem("userCred", JSON.stringify(cred))
          navigate('/',{replace: true});
          window.location.reload();
        } 
        else{
          setErrorMessage("Wrong Email or Password")
         }
    });
    }
       else if (input.email === "" && input.password === ""){
        setErrorMessage("Enter Your Details to Sign In")
    }
      
  }   

  return (
    <>
    <ResponsiveAppBar />
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 21,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'black' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign In
          </Typography>
          {error ? (<div className="error-msg">
          {errorMessage && <div className="error"> {errorMessage} <button onClick={closeError} id='close'>X</button> </div>}</div>):("")}
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  value={input.email}
                  onChange={(e)=>setInput({...input, [e.target.name]: e.target.value})}
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  value={input.password}
                  onChange={(e)=>setInput({...input, [e.target.name]: e.target.value})}
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              style={{background:'black', width:'180px', marginLeft:'110px'}}
            >
              Sign In
            </Button>
           
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
    </>
  );
}